import React from 'react'

const Companies = () => (
  <section id="companies" className="companies">
    <div className="container">
      <h2 className="section-title">
        過去の参加企業
        <br />
        <span className="help">※下記ロゴ企業は過去のイベントに参加した企業の一例になります</span>
      </h2>
      <div className="section-body">
        <div className="row">
          <div className="logo col s3 m2 offset-m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/sansei.png`} alt="株式会社サンセイランディック" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/gyao.png`} alt="株式会社GYAO" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/casio.png`} alt="カシオ計算機株式会社" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/mizuno.png`} alt="美津濃株式会社" />
          </div>
        </div>
        <div className="row">
          <div className="logo col s3 m2 offset-m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/neocareer.png`} alt="株式会社ネオキャリア" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/tokyogas.png`} alt="東京ガスｉネット株式会社" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/openhouse.png`} alt="株式会社オープンハウス" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/tablemark.png`} alt="テーブルマーク株式会社" />
          </div>
        </div>
        <div className="row">
          <div className="logo col s3 m2 offset-m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/kurazushi.png`} alt="株式会社くらコーポレーション" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/fujiyakuhin.png`} alt="株式会社富士薬品" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/primaham.png`} alt="プリマハム株式会社" />
          </div>
          <div className="logo col s3 m2">
            <img src={`${process.env.PUBLIC_URL}/assets/images/companies/avex.png`} alt="エイベックス株式会社" />
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Companies